module.exports = __webpack_public_path__ + "img/8004.a69f3909.gif";